<div
  class="timesheet-grid timesheet-day-header"
  [class.timesheet-day-header--footer]="showAsFooter"
  [ngStyle]="{ 'height.px': height }"
>
  {{ title }}
</div>
